import { configureStore } from '@reduxjs/toolkit';
import appReducer from './app-slice';
import authReducer from '../auth/auth-slice';
import workspaceGraphReducer from './workspace-graph-slice';
import contentTypeDataReducer from './content-type-data-slice';


export const store = configureStore({
    reducer: {
        app: appReducer,
        auth: authReducer,
        workspaceGraph: workspaceGraphReducer,
        contentTypeData: contentTypeDataReducer,
    }
});
